export const DevicesAndAppsListTitle = [
  { label: '设备编号', prop: 'deviceIdentifyCode' },
  { label: '设备名称', prop: 'name' },
  { label: '设备位置', prop: 'locationInfo', width: 160 },
  { label: '已安装产品App', prop: 'nameVersionArray', width: 160 },
  { label: '设备状态', prop: 'activated' }
]
